import React, { useCallback } from 'react';

import { useNavigate, Link, useParams } from 'react-router-dom';
import { Button, Heading, Text } from '@flixbus/honeycomb-react';
import { Icon, IconArrowLeft, IconDownload, IconOffer } from '@flixbus/honeycomb-icons-react';

import { useCancelFileStatus } from '../../hooks/useCancelFileStatus';
import styles from './upload-csv-success.module.scss';

export default function UploadCSVSuccess() {
  const navigate = useNavigate();

  const { id } = useParams();
  const { csv, progress } = useCancelFileStatus(id, 5000);

  const downloadCsv = useCallback(() => {
    if (!csv) return;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const element = document.createElement('a');
    element.href = url;
    element.download = `${id}.csv`;
    element.click();
    URL.revokeObjectURL(url);
  }, [csv, id]);

  return (
    <div className={styles.container}>
      <Button extraClasses={styles.back} Elem='a' RouterLink={Link} to='/'>
        <Icon InlineIcon={IconArrowLeft} />
        Back to home
      </Button>

      <div className={styles.title}>
        <Heading flushSpace size={1}>
          Your vouchers are being disabled
        </Heading>

        <Text className={styles.text}>
          Your request is being processed and may take up to 1 hour to complete. You can save this
          link and return later to check the progress at any time.
        </Text>
      </div>

      <div className={styles.progressContainer}>
        <Text>{progress.percentage}%</Text>
        <progress className={styles.progress} value={progress.value} max={progress.max} />
      </div>

      <div className={styles.actions}>
        {csv && (
          <Button appearance='link' onClick={downloadCsv}>
            <Icon InlineIcon={IconDownload} />
            Download
          </Button>
        )}
        <Button appearance='primary' onClick={() => navigate('/upload-csv')}>
          <Icon InlineIcon={IconOffer} />
          Upload another CSV
        </Button>
      </div>
    </div>
  );
}
